import { render, staticRenderFns } from "./VList.vue?vue&type=template&id=4ba9d950&scoped=true&"
import script from "./VList.vue?vue&type=script&lang=ts&"
export * from "./VList.vue?vue&type=script&lang=ts&"
import style0 from "./VList.vue?vue&type=style&index=0&id=4ba9d950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba9d950",
  null
  
)

export default component.exports